<template lang="pug">
  div
    div(style="font-size:20px;font-weight:bold") {{opts.title}}
    el-table.cl-table(:data="tableData" border style="width: 100%")
      el-table-column(v-for="l,p in tableHead" :prop="p" :label="l" :key="p")
        template(slot-scope="scope")
          a(:title="'筛选'+scope.row.label" @click="click(scope.row.label)") {{ scope.row[p] }}

</template>
<script>
export default {
  name: 'Pie',
  chart: null,
  props: {
    opts: Object,
  },
  data() {
    return {
      nTotal: 0,
      nEmpty: 0,
      tableData: [],
      tableHead: {
        index: '序号',
        label: '内容',
        y: '重复',
      },
    }
  },
  mounted() {
    return this.render()
  },
  methods: {
    load() {
      return this.opts.load().then(data => {
        this.nTotal = data.length
        data = data.filter(d => d.y > 1)
        data = data.sort((a, b) => b.y - a.y)
        return (this.tableData = data.map((d, k) => {
          d.index = k + 1
          // if !d._id?.replace(/\s/g,'')
          //   d._id = "空"
          d.label = d.name = d._id
          return d
        }))
      })
    },
    clickOnNull() {
      if (this.opts.clickOnNull) {
        return this.opts.clickOnNull()
      }
    },
    click(v) {
      let base
      return typeof (base = this.opts).click === 'function' ? base.click(v) : void 0
    },
    render() {
      return this.load().then(data => console.log(this.data))
    },
  },
}
</script>

